import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { qrEventsApi } from '../api/qrEventsApi';
import { notify } from "../../../util/toast";
import ActionButton from "../../../component/common/ActionButton";
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Paper,
    Stack,
    TextField,
    Typography,
} from '@mui/material';

function QrEventMyParticipantCheckPage() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const { eventName } = useParams();
    const history = useHistory();

    const displayName = eventName.replaceAll('_', ' ');

    const fetchApplications = async () => {
        if (!email) {
            notify('이메일을 입력해주세요.', 'warning')
            return;
        }
        setLoading(true);
        try {
            const response = await qrEventsApi.publicGetParticipant(displayName, email);
            history.push('/qr-event-participant-my-view', {
                uuid: response.privateCode,
                name: response.name,
                affiliation: response.affiliation,
                contactNumber: response.contactNumber,
                email: response.email,
                eventName,
            });
        } catch {
            notify('등록되지 않은 참가자이거나 존재하지 않는 행사입니다.', 'error')
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
            <Container maxWidth="xs">
                <Paper elevation={0} sx={{ p: { xs: 3, sm: 4 }, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Stack spacing={0.5} sx={{ mb: 3 }}>
                        <Typography sx={{ fontSize: 20, fontWeight: 800, letterSpacing: '-0.3px', color: 'text.primary' }}>
                            신청 내역 조회
                        </Typography>
                        <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>{displayName}</Typography>
                    </Stack>

                    <Stack spacing={2}>
                        <TextField
                            label="이메일"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') fetchApplications(); }}
                            fullWidth
                            autoFocus
                        />
                        <ActionButton
                            variant="primary"
                            onClick={fetchApplications}
                            loading={loading}
                            label={loading ? '조회 중...' : '신청 내역 조회'}
                            fullWidth
                            startIcon={false}
                            sx={{ py: 1.25 }}
                        />
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}

export default QrEventMyParticipantCheckPage;
